/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetOtherPrintDefDto } from './GetOtherPrintDefDto';
import {
    GetOtherPrintDefDtoFromJSON,
    GetOtherPrintDefDtoFromJSONTyped,
    GetOtherPrintDefDtoToJSON,
} from './GetOtherPrintDefDto';
import type { GetUserDto } from './GetUserDto';
import {
    GetUserDtoFromJSON,
    GetUserDtoFromJSONTyped,
    GetUserDtoToJSON,
} from './GetUserDto';
import type { GetExamDto } from './GetExamDto';
import {
    GetExamDtoFromJSON,
    GetExamDtoFromJSONTyped,
    GetExamDtoToJSON,
} from './GetExamDto';

/**
 * 
 * @export
 * @interface GetOtherPrintDto
 */
export interface GetOtherPrintDto {
    /**
     * 
     * @type {string}
     * @memberof GetOtherPrintDto
     */
    id: string;
    /**
     * 
     * @type {GetExamDto}
     * @memberof GetOtherPrintDto
     */
    exam?: GetExamDto | null;
    /**
     * 
     * @type {Date}
     * @memberof GetOtherPrintDto
     */
    date?: Date | null;
    /**
     * 
     * @type {GetOtherPrintDefDto}
     * @memberof GetOtherPrintDto
     */
    otherPrintDef?: GetOtherPrintDefDto | null;
    /**
     * 
     * @type {GetUserDto}
     * @memberof GetOtherPrintDto
     */
    user?: GetUserDto | null;
    /**
     * 
     * @type {string}
     * @memberof GetOtherPrintDto
     */
    comments?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOtherPrintDto
     */
    objective?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOtherPrintDto
     */
    directsTo?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetOtherPrintDto
     */
    active?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetOtherPrintDto
     */
    withoutSign?: boolean | null;
}

/**
 * Check if a given object implements the GetOtherPrintDto interface.
 */
export function instanceOfGetOtherPrintDto(value: object): value is GetOtherPrintDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetOtherPrintDtoFromJSON(json: any): GetOtherPrintDto {
    return GetOtherPrintDtoFromJSONTyped(json, false);
}

export function GetOtherPrintDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOtherPrintDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'exam': json['exam'] == null ? undefined : GetExamDtoFromJSON(json['exam']),
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'otherPrintDef': json['otherPrintDef'] == null ? undefined : GetOtherPrintDefDtoFromJSON(json['otherPrintDef']),
        'user': json['user'] == null ? undefined : GetUserDtoFromJSON(json['user']),
        'comments': json['comments'] == null ? undefined : json['comments'],
        'objective': json['objective'] == null ? undefined : json['objective'],
        'directsTo': json['directsTo'] == null ? undefined : json['directsTo'],
        'active': json['active'] == null ? undefined : json['active'],
        'withoutSign': json['withoutSign'] == null ? undefined : json['withoutSign'],
    };
}

export function GetOtherPrintDtoToJSON(value?: GetOtherPrintDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'exam': GetExamDtoToJSON(value['exam']),
        'date': value['date'] == null ? undefined : ((value['date'] as any).toISOString()),
        'otherPrintDef': GetOtherPrintDefDtoToJSON(value['otherPrintDef']),
        'user': GetUserDtoToJSON(value['user']),
        'comments': value['comments'],
        'objective': value['objective'],
        'directsTo': value['directsTo'],
        'active': value['active'],
        'withoutSign': value['withoutSign'],
    };
}

